import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentCreate from 'material-ui/svg-icons/content/create';

const styles = {
    icon: {overflow: 'inherit'},
};

const EditButtonWithType = ({basePath = '', record = {}}) => (
    <IconButton
        containerElement={<Link
            to={`${basePath}/${encodeURIComponent((record) ? record.type : '')}/${(record) ? record.id : ''}`}/>}
        style={styles.icon}
    >
        <ContentCreate color={FuseTheme.palette.primary1Color}/>
    </IconButton>
);

EditButtonWithType.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

EditButtonWithType.defaultProps = {
    style: {padding: 0},
};

export default EditButtonWithType;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/EditButtonWithType.js